import { ReduxStore } from '../interfaces/store';
import { createSelector } from 'reselect';

const root = (state: ReduxStore) => state.recentlyViewedSearches;

export const recentlyViewedSearches = createSelector(
  root,
  root => root?.searches ?? []
);
